import {
  deleteRole,
  getAllRoles,
  newRole,
  updateRole,
} from '../../services/roles';

export default {
  /**
   * Get all the roles
   * @param commit
   * @returns {Promise<void>}
   */
  async fetchAllRoles({ commit }) {
    const response = await getAllRoles();
    commit('setProperty', { property: 'roles', payload: response });
  },

  /**
   *
   * @param commit
   * @param roleId
   * @returns {Promise<void>}
   */
  async deleteRole({ commit }, { roleId }) {
    await deleteRole(roleId);
    commit('delProperty', { property: roleId });
  },

  /**
   *
   * @param context
   * @param roleId
   * @param role
   * @returns {Promise<void>}
   */
  async updateRole(context, { roleId, role }) {
    await updateRole(roleId, role);
  },

  /**
   *
   * @param context
   * @param role
   * @returns {Promise<void>}
   */
  async newRole({ commit }, { role }) {
    const response = await newRole(role);
    commit('setNewRole', { payload: response });
  },
};
